import i18n from "../i18n";

class AddressUtils {
  convertLatLongToAddress(lat, lng, callback) {
    const geocoder = new google.maps.Geocoder();
    const latLng = new google.maps.LatLng(lat, lng);

    geocoder.geocode({'latLng': latLng}, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          callback(results[0].formatted_address);
        } else {
          callback('Aucun résultat trouvé');
        }
      } else {
        callback('Erreur de géocodage : ' + status);
      }
    });
  }


}

export default new AddressUtils()



// WEBPACK FOOTER //
// ./src/utils/AddressUtils.js